import script from "./AIAssistantAttendanceStartCTA.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIAssistantAttendanceStartCTA.vue?vue&type=script&setup=true&lang=ts"

import "./AIAssistantAttendanceStartCTA.vue?vue&type=style&index=0&id=6d4012b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d4012b3"]])

export default __exports__